module.exports = __webpack_public_path__ + "static/media/StatsRadio_LeGuide_Fr.1cfc13bf.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/statsradio/modules/tutorials/assets/pdfs/fr/StatsRadio_LeGuide_Fr.pdf
// module id = ./src/statsradio/modules/tutorials/assets/pdfs/fr/StatsRadio_LeGuide_Fr.pdf
// module chunks = 18